import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=39a2dc4e&"
import script from "./domains.vue?vue&type=script&lang=js&"
export * from "./domains.vue?vue&type=script&lang=js&"
import style0 from "./domains.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports